module.exports = __webpack_public_path__ + "static/media/application-crop-tablet.9c09047c.jpg";